import { inject, autoinject } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { State } from '../../../../services/global-state';

// @inject(State)
@autoinject
export class CardsAcceptedCustomElement {
	globalState: State;
	showVisa: boolean = false;
	showMasterCard: boolean = false;
	showDiscover: boolean = false;
	showAmex: boolean = false;
	showDiners: boolean = false;
	showJCB: boolean = false;
	cardsAcceptedSubscription: Subscription;

	constructor(globalState: State, private eventAggregator: EventAggregator) {
		this.globalState = globalState;
	}

	bind() {
		this.applyAcceptedCards(this.globalState.business.portalSettings.cardsAccepted);
	}

	attached(){
		if (this.globalState.features.consumerPortalMultiZidEzPay) {
			this.cardsAcceptedSubscription = this.eventAggregator.subscribe('portalSettingsCardsAcceptedChanged', acceptedCards => {
				this.applyAcceptedCards(acceptedCards);
			});
		}
	}

	detached() {
		if (this.cardsAcceptedSubscription) {
			this.cardsAcceptedSubscription.dispose();
		}
	}

	applyAcceptedCards(accepted) {
		try {
			this.showVisa = accepted.visa || false;
			this.showMasterCard = accepted.mastercard || false;
			this.showDiscover = accepted.discover || false;
			this.showAmex = accepted.amex || false;
			this.showDiners = accepted.diners || accepted.cartblanch || false;
			this.showJCB = accepted.jcb || false;
		}
		catch (err) {
			console.error('Error occurred in Cards-Accepted component.');
		}
	}
}
